import _StickyTool from './StickyTool';

import './style/index.js';

export type { StickyToolProps } from './StickyTool';
export type { StickyItemProps } from './StickyItem';
export * from './type';

export const StickyTool = _StickyTool;
export default StickyTool;
